// Latest payment recorded against a course enrollment, or null when the
// student has not paid anything towards that course yet.
export const getLastPaymentDate = (payment) => {
    const history = payment?.paymentHistory || [];
    let latest = null;

    history.forEach((entry) => {
        if (!entry?.paymentDate) return;
        const date = new Date(entry.paymentDate);
        if (Number.isNaN(date.getTime())) return;
        if (!latest || date > latest) latest = date;
    });

    return latest;
};
